import Vue from 'vue'
import { COOKIE_USER, COOKIE_AUTH, COOKIE_OTP } from './../store/auth/constants';
const ACCESS_TOKEN_KEY = "app_access_token";
const REFRESH_TOKEN_KEY = "app_refresh_token";
const EXPIRED_TOKEN = "app_expired_in";
// import { Base64 } from '@/helpers/functions'
import Cookies from 'js-cookie';
// import router from '@/router'

// export const getAccessToken = () => {
//   // Check expired token
//   // if ()

//   return window.localStorage.getItem(ACCESS_TOKEN_KEY);
// };

export const getRefreshToken = () => {
  return window.localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const getExpiredToken = () => {
  return window.localStorage.getItem(EXPIRED_TOKEN);
};
export const getAccessToken = () => {

  if (window.location.href.includes('mobile')) {
    const url = new URL(window.location.href)
    return url.searchParams.get('token')
      // console.log('Window: ', url.searchParams.get('token'))
  } else {
    return Cookies.get(COOKIE_USER);
  }
  // console.log('access_token: ', window.location.href)
};
export const getAuth = () => {
    return Cookies.get(COOKIE_AUTH) ? JSON.parse(Cookies.get(COOKIE_AUTH)) : null;
}
export const getOTP = () => {
    const authInfo = getAuth()
    return authInfo && authInfo.otp ? atob(authInfo.otp) : null
    // return Cookies.get(COOKIE_OTP) ? atoa(Cookies.get(COOKIE_AUTH)) : null;
}

export const saveAuth = (auth) => {
    Cookies.set(COOKIE_AUTH, JSON.stringify(auth), { expires: 2 });
}
export const saveToken = (access_token, expired_at = 2) => {
    // only minute: (1 / 1440) * expired_at    cons
    Cookies.set(COOKIE_USER, access_token, { expires: expired_at });
};

// export const saveToken = (access_token, refresh_token, expired_in) => {
//   window.localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
//   window.localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
//   window.localStorage.setItem(EXPIRED_TOKEN, expired_in);
// };

export const destroyToken = () => {
    Cookies.remove(COOKIE_USER, { path: '/' });
    Cookies.remove(COOKIE_AUTH, { path: '/' });
    Cookies.remove(COOKIE_OTP, { path: '/' });
    localStorage.clear();
};

export default { 
    getAccessToken, 
    getRefreshToken, 
    getExpiredToken, 
    saveToken, 
    destroyToken, 
    getAuth, 
    saveAuth,
    getOTP
};